export default __webpack_public_path__ + "static/marco-circle-70f789c0c5b2f6d8a80c30e66122e28a.png";